<template>
  <div>
    <div class="font-14 font-weight-bold">
      <span class="color-orange-light-2 mr-2">
        {{ $t('lblWizardStep5SectionTitle.text') }}
        <span class="align-sub">* * *</span>
      </span>
      <span class="color-dark-blue">
        {{ $t('AttachDocuments') | upper }}
      </span>
    </div>

    <!-- Nueva Sección para Documentos Siempre Requeridos -->
    <!--  <div v-if="alwaysRequiredDocuments.length > 0" class="mt-4">
  <b-form-checkbox-group
    id="checkbox-group-always-required"
    v-model="alwaysRequiredIds"
    class="ml-4 pl-1"
    :disabled="true"
  >
    <b-form-checkbox
      v-for="(item, index) in alwaysRequiredDocuments"
      :key="`always-required-item-${index}`"
      :value="item.id"
      disabled
      class="d-block my-3"
    >
      <span class="color-black-3 font-14 font-weight-bold">
        {{ item.name }} -
      </span>
      <span class="color-black-3 font-14">{{ item.description }}</span>
    </b-form-checkbox>
  </b-form-checkbox-group>
</div> -->

    <validation-observer ref="formRef" v-slot="{}" tag="form">
      <div>
        <div>
          <div class="d-flex align-items-center mt-4">
            <span class="fa-stack fa-1x font-10 ml-n1">
              <em class="fas fa-circle fa-stack-2x color-orange-light-2"></em>
              <span class="fa-stack-1x color-white">1</span>
            </span>
            <span class="color-black-2 font-weight-bold font-14 ml-2">
              {{ $t('lblWizarStep5RequiredDocumentTitle.text') }}
            </span>
          </div>
          <b-form-checkbox
            v-for="(item, index) in options"
            :key="`chk-item-${index}`"
            :value="item.id"
            :disabled="isReadOnly || item.alwaysRequired || isItemDisabled(item)"
            v-if="!item.alwaysRequired"
            class="d-block my-3"
            v-model="model.selectedLetters"
          >
            <span class="color-black-3 font-14 font-weight-bold">
              {{ item.name }} -
            </span>
            <span
              class="color-black-3 font-14"
              v-b-tooltip.hover.right="tooltipItemDisabled(item)"
            >
              {{ item.description }}
            </span>
          </b-form-checkbox>

          <validation-provider
            :rules="{ required_if: !model.selectedLetters.length }"
            v-slot="{ errors }"
          >
            <custom-error
              v-if="errors[0]"
              class="no-border mt-2"
              :message="`${$t('RequiredLetter.ErrorMessage')}`"
            />
          </validation-provider>
        </div>

        <!-- Sección de Importancia de la Investigación -->
        <div class="mt-4">
          <div class="d-flex align-items-center mt-4">
            <span class="fa-stack fa-1x font-10 ml-n1">
              <em class="fas fa-circle fa-stack-2x color-orange-light-2"></em>
              <span class="fa-stack-1x color-white">2</span>
            </span>
            <span class="color-black-2 font-weight-bold font-14 ml-2">
              {{ $t('InvestigationImportanceDescription') | upper }}
            </span>
          </div>
          <div v-if="!isReadOnly" class="mt-3">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              {{ $t('DescribeRelevanceStudyResearchField') }}:
            </div>
            <validation-provider rules="required" v-slot="{ errors }">
              <custom-text-area
                v-model="model.investigationImportanceDescription"
                :placeholder="$t('WriteComment')"
                :maxlength="500"
                show-char-count
                class="mt-3"
                :error="errors[0]"
                :custom-error-msg="$t('RequiredField')"
              />
            </validation-provider>
          </div>
          <div v-else class="bg-white rounded p-3 mt-3">
            <div class="color-gray-18 font-14">
              {{ $t('DescribeRelevanceStudyResearchField') }}:
            </div>
            <span class="color-black font-14">
              {{ model.investigationImportanceDescription | empty }}
            </span>
          </div>
        </div>

        <!-- Documentos adicionales -->
        <div v-if="!isNewRequest" class="mt-4">
          <documents
            ref="documentRef"
            :item-id="itemId"
            :documents="documentMappedList"
            :is-read-only="isReadOnly"
            @on-refresh-document="$emit('on-refresh-document')"
          />
          <document-additionals
            class="mt-5"
            :item-id="itemId"
            :documents="documentAdditionalMappedList"
            :categories="availableCategories"
            :is-read-only="isReadOnly"
            @on-refresh-document="$emit('on-refresh-document')"
          />
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
//libs
import CustomTextArea from 'CustomTextArea';
import CustomError from 'custom-error';
import { i18n } from '@/i18n';

//constants
import attachmentCategories, {
  attachmentCategoryDescriptions,
} from '@/utils/constants/attachmentCategories';
import Documents from '@/views/request/components/Documents.vue';
import DocumentAdditionals from '@/views/request/components/DocumentAdditionals.vue';
import { getAttachmentInitCatalog as _getAttachmentInitCatalog } from '@/services/app.api';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';

export default {
  name: 'DocumentValidation',
  mixins: [alertMixin],
  components: {
    Documents,
    DocumentAdditionals,
    CustomTextArea,
    CustomError,
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    itemId: {
      type: Number,
      required: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    isNewRequest: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      model: {
        ...this.info,
        selectedLetters: this.getCheckedLetter(this.info),
      } || {
        selectedLetters: [],
      },
      options: [
        {
          id: attachmentCategories.InstitutionalReviewBoard,
          name: 'I.R.B',
          description:
            attachmentCategoryDescriptions[
              attachmentCategories.InstitutionalReviewBoard
            ],
          order: 1,
          alwaysRequired: true,
        },
        {
          id: attachmentCategories.InvestigationImpactsGuardian,
          name: 'C.C.I.P',
          description:
            attachmentCategoryDescriptions[
              attachmentCategories.InvestigationImpactsGuardian
            ],
          order: 2,
          alwaysRequired: false,
        },
        {
          id: attachmentCategories.InvestigationImpactsTeachers,
          name: 'C.C.I.P',
          description:
            attachmentCategoryDescriptions[
              attachmentCategories.InvestigationImpactsTeachers
            ],
          order: 3,
          alwaysRequired: false,
        },
        {
          id: attachmentCategories.InvestigationImpactsPrincipal,
          name: 'C.C.I.D',
          description:
            attachmentCategoryDescriptions[
              attachmentCategories.InvestigationImpactsPrincipal
            ],
          order: 4,
          alwaysRequired: false,
        },
        {
          id: attachmentCategories.InvestigationImpactsStudents,
          name: 'C.A.I.E',
          description:
            attachmentCategoryDescriptions[
              attachmentCategories.InvestigationImpactsStudents
            ],
          order: 5,
          alwaysRequired: false,
        },
        {
          id: attachmentCategories.InvestigationShareTeachers,
          name: 'C.C.M',
          description:
            attachmentCategoryDescriptions[
              attachmentCategories.InvestigationShareTeachers
            ],
          order: 6,
          alwaysRequired: false,
        },
        {
          id: attachmentCategories.InvestigationInpactsGeneral,
          name: 'C.C.G',
          description:
            attachmentCategoryDescriptions[
              attachmentCategories.InvestigationInpactsGeneral
            ],
          order: 7,
          alwaysRequired: false,
        },
      ],
      catalog: {}, //,
      //alwaysRequiredDocuments: [],
      //alwaysRequiredIds: []
    };
  },
  computed: {
    documentMappedList() {
      if (this.info === undefined) return [];

      const documents = this.info.documents ?? [];
      const requiredDocumentCategories =
        this.info.requiredDocumentCategories ?? [];

      var selectedDocuments = this.model.selectedLetters?.map((item) => {
        const document = documents.find((d) => d.documentCategoryId === item);
        return {
          id: item,
          documentCategoryCode:
            this.options.find((x) => x.id === item)?.name ?? '',
          documentCategoryName: attachmentCategoryDescriptions[item],
          documentId: document?.documentId,
          filename: document?.filename,
          hiddenPublic: true,
          stampingStatus: document?.stampingStatus,
          stampingDate: document?.stampingDate,
          processingError: document?.processingError,
          processingAttempts: document?.processingAttempts,
        };
      });

      var documentCategories = requiredDocumentCategories.map((item) => {
        const document = documents.find(
          (d) => d.documentCategoryId === item.documentCategoryId
        );
        return {
          id: item.documentCategoryId,
          documentCategoryName: item.documentCategoryName,
          documentId: document?.documentId,
          filename: document?.filename,
          isPublic: document?.isPublic,
          stampingStatus: document?.stampingStatus,
          stampingDate: document?.stampingDate,
          processingError: document?.processingError,
          processingAttempts: document?.processingAttempts,
        };
      });
      var result = [...selectedDocuments, ...documentCategories];
      return result;
    },
    documentAdditionalMappedList() {
      const excludeDocumentCategoryIds = Object.values(attachmentCategories);
      const excludeRequiredDocumentCategories =
        this.info.requiredDocumentCategories.map(
          (item) => item.documentCategoryId
        );

      const documents = (this.info.documents ?? []).filter(
        (x) =>
          !excludeDocumentCategoryIds.includes(x.documentCategoryId) &&
          !excludeRequiredDocumentCategories.includes(x.documentCategoryId)
      );

      var result = documents.map((item) => ({
        id: item.documentCategoryId,
        documentCategoryName: item.documentCategoryName,
        documentId: item.documentId,
        filename: item.filename,
      }));

      return result;
    },
    availableCategories() {
      const excludeDocumentCategoryIds = Object.values(attachmentCategories);
      return this.catalog?.categories?.filter(
        (s) => !excludeDocumentCategoryIds.includes(s.id)
      );
    },
  },
  async mounted() {
    await this.getAttachmentInitCatalog();
    this.initializeSelectedLetters();
  },
  methods: {
    isItemDisabled(item) {
      var result = this.documentMappedList.some(
        (x) => x.id === item.id && x.documentId !== undefined
      );

      return result;
    },
    initializeSelectedLetters() {
      this.options.forEach((option) => {
        if (
          option.alwaysRequired &&
          !this.model.selectedLetters.includes(option.id)
        ) {
          this.model.selectedLetters.push(option.id);
        }
      });

      const approvalStatus = this.info || {};
      if (Object.keys(approvalStatus).length) {
        if (approvalStatus.approvedParents) {
          this.addIfNotPresent(
            attachmentCategories.InvestigationImpactsGuardian
          );
        }
        if (approvalStatus.approvedDirectors) {
          this.addIfNotPresent(
            attachmentCategories.InvestigationImpactsPrincipal
          );
        }
        if (approvalStatus.approvedStudents) {
          this.addIfNotPresent(
            attachmentCategories.InvestigationImpactsStudents
          );
        }
        if (approvalStatus.approvedTeachers) {
          this.addIfNotPresent(
            attachmentCategories.InvestigationImpactsTeachers
          );
        }
        if (approvalStatus.approvedSharedTeachers) {
          this.addIfNotPresent(attachmentCategories.InvestigationShareTeachers);
        }
        if (approvalStatus.approvedGeneral) {
          this.addIfNotPresent(
            attachmentCategories.InvestigationInpactsGeneral
          );
        }
      }

      this.model.selectedLetters = [...this.model.selectedLetters];
    },
    changeCheckbox(value, documentId) {
      if (value) {
        this.addIfNotPresent(documentId);
      } else {
        this.model.selectedLetters = this.model.selectedLetters.filter(
          (x) => x !== documentId
        );
      }      
    },
    addIfNotPresent(documentId) {
      if (!this.model.selectedLetters.includes(documentId)) {
        this.model.selectedLetters.push(documentId);
      }
    },
    tooltipItemDisabled(item) {
      if (this.isItemDisabled(item)) {
        return i18n.t('MustDeleteDocument');
      }
    },
    getModel() {
      return { ...this.model };
    },
    setModel(value) {
      this.model = {
        ...this.model,
        ...value,
      };
    },
    async validate() {
      let hasAllDocuments = true;
      if (this.$refs.documentRef?.documents.length) {
        hasAllDocuments = this.$refs.documentRef?.documents.every(
          (x) => x.documentId
        );
      }

      const isValid = await this.$refs.formRef.validate();
      if (!isValid || !hasAllDocuments) {
        return false;
      }

      // Combinar los documentos seleccionados con los siempre requeridos
      // this.model.selectedLetters = [
      //   ...new Set([...this.model.selectedLetters, ...this.alwaysRequiredIds]),
      // ];

      return true;
    },
    getCheckedLetter(approvalStatus) {
      const selectedLetters = [];

      // this.options.forEach((option) => {
      //   if (option.alwaysRequired) {
      //     selectedLetters.push(option.id);
      //   }
      // });

      if (Object.keys(approvalStatus || {}).length) {
        if (approvalStatus.approvedParents)
          selectedLetters.push(
            attachmentCategories.InvestigationImpactsGuardian
          );

        if (approvalStatus.approvedDirectors)
          selectedLetters.push(
            attachmentCategories.InvestigationImpactsPrincipal
          );

        if (approvalStatus.approvedStudents)
          selectedLetters.push(
            attachmentCategories.InvestigationImpactsStudents
          );

        if (approvalStatus.approvedTeachers)
          selectedLetters.push(
            attachmentCategories.InvestigationImpactsTeachers
          );

        if (approvalStatus.approvedSharedTeachers)
          selectedLetters.push(attachmentCategories.InvestigationShareTeachers);

        if (approvalStatus.approvedGeneral)
          selectedLetters.push(
            attachmentCategories.InvestigationInpactsGeneral
          );
      }

      return selectedLetters;
    },
    async getAttachmentInitCatalog() {
      this.catalog = (await _getAttachmentInitCatalog()).data;

      // this.alwaysRequiredDocuments = this.catalog.categoriesAlwaysRequired;
      // this.alwaysRequiredIds = this.alwaysRequiredDocuments.map((doc) => doc.id);
    },
  },
};
</script>
<style>
input[type='checkbox']:disabled + label {
  opacity: 0.7;
}
</style>
